import { useEffect } from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

// AGB/Datenschutz sind rechtlich noch nicht final geprueft (Task #35) - bis zur anwaltlichen
// Freigabe zeigt diese Seite bewusst nur einen ehrlichen Platzhalter statt erfundener
// Fake-Inhalte. Route bleibt oeffentlich erreichbar (kein ProtectedRoute), damit Verlinkung/
// § 312k-Kuendigung schon jetzt testbar sind. Sobald die finalen, zweisprachigen Texte aus
// ../Legal/ freigegeben sind, kommen sie hier rein statt des Platzhalters.
const TermsAndPrivacyPage = () => {
    const { t } = useTranslation('platformPages');

    useEffect(() => {
        document.title = t('termsPrivacy.title');
    }, [t]);

    return (
        <div className='container-fluid py-4 overflow-auto' style={{ maxWidth: 640 }}>
            <h1>{t('termsPrivacy.title')}</h1>
            <p>{t('termsPrivacy.pending')}</p>
            <p>{t('termsPrivacy.pendingBody')}</p>
            <p>
                {t('termsPrivacy.contactHint')}{' '}
                <Link to="/impressum">{t('termsPrivacy.contactLink')}</Link>.
            </p>
            <p>
                {t('termsPrivacy.cancelHint')}{' '}
                <Link to="/kuendigung">{t('termsPrivacy.cancelLink')}</Link>
            </p>
        </div>
    );
};

export default TermsAndPrivacyPage;
